import { render, staticRenderFns } from "./BLCRemodal.vue?vue&type=template&id=0d13c1b6&scoped=true&lang=pug&"
import script from "./BLCRemodal.vue?vue&type=script&lang=js&"
export * from "./BLCRemodal.vue?vue&type=script&lang=js&"
import style0 from "./BLCRemodal.vue?vue&type=style&index=0&id=0d13c1b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d13c1b6",
  null
  
)

export default component.exports